import React from 'react'
import { FormattedMessage } from 'gatsby-plugin-intl'
import { useBreakpoint, TABLET } from 'masterplan-shared'

import { DOM_ID_APPLICATION_FORM, URL_APPLICATION } from '@/constants'
import { Banner, LinkButton, Caption } from '@/components'
import { interpolateNewline } from '@/utils'

import styles from './JobsDescriptionBanner.module.css'

const JobsDescriptionBanner: React.FC<{ offerSlug: string }> = ({
  offerSlug,
}) => {
  const interpolate = useBreakpoint({ breakpoint: TABLET })

  return (
    <section>
      <Banner>
        <div className={styles.bannerContent}>
          <Caption variant="h2" className={styles.title}>
            <FormattedMessage id="jobs-description.banner.title" />
          </Caption>
          <p className={styles.paragraph}>
            <FormattedMessage
              id="jobs-description.banner.paragraph"
              values={{
                ...interpolateNewline({ interpolate }),
              }}
            />
          </p>
          <LinkButton
            className={styles.button}
            to={`${URL_APPLICATION}?offer=${offerSlug}#${DOM_ID_APPLICATION_FORM}`}
            variant="white">
            <FormattedMessage id="jobs-description.banner.button" />
          </LinkButton>
        </div>
      </Banner>
    </section>
  )
}

export default JobsDescriptionBanner
